import Model, { attr, belongsTo } from "@ember-data/model";
import type HealthCentre from "./health-centre";

export default class CareGiver extends Model {
  @attr("string") declare firstName: string;
  @attr("string") declare lastName: string;
  @attr("string") declare role: string;
  @attr("string") declare email: string;
  @attr("string") declare phone: string;
  @attr("string") declare address: string;
  @attr("string") declare comments: string;

  @belongsTo("health-centre", {
    async: false,
    inverse: "careGivers"
  })
  declare healthCentre: HealthCentre;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "care-giver": CareGiver;
  }
}
